<style lang="less">
</style>
<template>
    <span>
        <Drawer title="继续教育课程" :closable="false" placement="right" v-model="transfercourse" width="60%">
            <Row class="operation">
                <Button @click="add" type="primary" icon="md-add">新增</Button>
                <circleLoading v-if="operationLoading"/>
            </Row>
            <Row style="padding-top: 5px">
                <Table :loading="loading" border :columns="columns" :data="data" ref="userTable"></Table>
            </Row>
            <Row type="flex" justify="end" class="page">
                <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
            </Row>
        </Drawer>
        <continuing-drawer ref="continuingDrawer"></continuing-drawer>
    </span>
</template>

<script>
    import {selectContinueCourse,delContinueCourse,resetContinueCourse } from "@/api/bus";
    import continuingDrawer from "./continuing-drawer";
    export default {
        name: "continuingManage",
        components: {
            continuingDrawer
        },
        data() {
            return {
                loading: false, // 表单加载状态
                operationLoading: false,
                transfercourse: false,
                drop: false,
                selectCount: 0, // 多选计数
                selectList: [], // 多选数据
                dropDownContent: "展开",
                dropDownIcon: "ios-arrow-down",
                searchForm: {
                    pageNumber: 1, // 当前页数
                    pageSize: 10, // 页面大小
                    sort: "createTime", // 默认排序字段
                    order: "desc", // 默认排序方式
                    certificateId: '',

                },
                selectDate: null, //选择日期绑定modal
                columns: [
                    {
                        type: "index",
                        width: 50,
                        align: "center"
                    },
                    {
                        title: "课程名称",
                        align: "center",
                        key: "courseTitle"
                    },
                    {
                        title: "兑换学时",
                        align: "center",
                        key: "period"
                    },
                    {
                        title: "操作",
                        key: "action",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small"
                                        },
                                        style: {
                                            marginRight: "5px"
                                        },
                                        on: {
                                            click: () => {
                                                this.edit(params.row);
                                            }
                                        }
                                    },
                                    "编辑"
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "error",
                                            size: "small"
                                        },
                                        on: {
                                            click: () => {
                                                this.remove(params.row);
                                            }
                                        }
                                    },
                                    "删除"
                                )
                            ]);
                        }
                    }],
                data: [], // 表单数据
                total: 0 // 表单数据总数
            }
        },
        methods: {
            showDrawer(params){
                this.transfercourse = true;
                if (params.id) {
                    this.searchForm.certificateId = params.id;
                    this.getDataList();
                }
            },
            getDataList() {
                this.loading = true;
                selectContinueCourse(this.searchForm).then(res => {
                    console.info(res)
                    this.loading = false;
                    this.data = res.data.rows;
                    this.total = res.data.total;
                });
            },
            resetContinueCourse(){
                resetContinueCourse(this.searchForm.certificateId).then(res => {
                    this.loading = false;
                    if (res.status === true) {
                        this.$parent.getDataList();
                    }
                });
            },
            remove(v) {
                this.$Modal.confirm({
                    title: "确认删除",
                    content: "您确认要删除该课程吗?",
                    onOk: () => {
                        delContinueCourse(v.id).then(res => {
                            if (res.status === true) {
                                this.$Message.success("删除成功");
                                this.resetContinueCourse();
                                this.getDataList();
                                this.$parent.getDataList();
                            }
                        });
                    }
                });
            },
            add() {
                let query = {certificateId: this.searchForm.certificateId};
                this.$refs.continuingDrawer.showDrawer(query);
            },
            edit(v) {
                this.$refs.continuingDrawer.showDrawer(v);
            },
            dropDown() {
                if (this.drop) {
                    this.dropDownContent = "展开";
                    this.dropDownIcon = "ios-arrow-down";
                } else {
                    this.dropDownContent = "收起";
                    this.dropDownIcon = "ios-arrow-up";
                }
                this.drop = !this.drop;
            },
            changePage(v) {
                this.searchForm.pageNumber = v;
                this.getDataList();
                this.clearSelectAll();
            },
            changePageSize(v) {
                this.searchForm.pageSize = v;
                this.getDataList();
            },
            changeSort(e) {
                this.searchForm.sort = e.key;
                this.searchForm.order = e.order;
                if (e.order === "normal") {
                    this.searchForm.order = "";
                }
                this.getDataList();
            },
            clearSelectAll() {
                this.$refs.table.selectAll(false);
            },
        },
        mounted() {
        }
    }
</script>
